import { render, staticRenderFns } from "./SigManager.vue?vue&type=template&id=322d53f0&scoped=true"
import script from "./SigManager.vue?vue&type=script&lang=js"
export * from "./SigManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d53f0",
  null
  
)

export default component.exports